<script lang="ts">
	// @ts-nocheck
	import * as Carousel from '$lib/components/ui/carousel';
	import allToursData from '$lib/data/allTours.json';
	import TourCard from '$lib/components/tours/TourCard.svelte';

	interface Props {
		selected?: string;
		heading?: string;
		productCode?: string;
	}

	let { selected = 'featured', heading = 'Featured tours', productCode = '' }: Props = $props();

	const productCodes = ['PTC0KJ', 'P18ZC5', 'PQ5CJC', 'PJHLE0', 'PNNK81', 'PNVP8M', 'P6GE12'];
	const dayTours = ['P18ZC5', 'PJHLE0', 'PNVP8M', 'P01GQC', 'PQ5CJC', 'PTC0KJ'];
	const multiDayTours = ['PTWH1T', 'PVHGUQ', 'P1VDC1', 'P0V9R2'];
	const shoreExcursions = ['P0J8QR', 'PM0VRV', 'PB2LG2', 'PSP9WG', 'P9TVKQ'];
	const privateTours = ['P80WBP', 'PUYDUT', 'PMFU3K', 'PVSUAB', 'P0QZS7'];

	function removeProductCodeFromLists(code) {
		const lists = [productCodes, dayTours, multiDayTours, shoreExcursions, privateTours];
		lists.forEach((list) => {
			const index = list.indexOf(code);
			if (index !== -1) {
				list.splice(index, 1);
			}
		});
	}

	if (productCode) {
		removeProductCodeFromLists(productCode);
	}

	let featuredTours = $derived(
		selected === 'featured'
			? allToursData.filter((tour) => productCodes.includes(tour.productCode))
			: selected === 'dayTours'
				? allToursData.filter((tour) => dayTours.includes(tour.productCode))
				: selected === 'multiDayTours'
					? allToursData.filter((tour) => multiDayTours.includes(tour.productCode))
					: selected === 'shoreExcursions'
						? allToursData.filter((tour) => shoreExcursions.includes(tour.productCode))
						: selected === 'privateTours'
							? allToursData.filter((tour) => privateTours.includes(tour.productCode))
							: []
	);
</script>

<section
	class="mx-auto flex max-w-7xl flex-col overflow-hidden px-4 pb-12 pt-20 lg:overflow-visible"
>
	<h2
		class="mt-10 scroll-m-20 pb-12 font-heading text-2xl font-semibold tracking-tight transition-colors first:mt-0 lg:text-3xl"
	>
		{heading}
	</h2>
	<div class="mx-auto mt-6 flex w-full max-w-7xl">
		<Carousel.Root class="w-full" opts={{ align: 'start', loop: true }}>
			<Carousel.Content peek>
				{#each featuredTours as tour}
					<Carousel.Item class="basis-[85%] lg:basis-1/3">
						<TourCard {tour} />
					</Carousel.Item>
				{/each}
			</Carousel.Content>
			<Carousel.Previous />
			<Carousel.Next />
		</Carousel.Root>
	</div>
</section>
